import { View, Text } from "@react-pdf/renderer";
import { stylePDF as sg } from "./styles";
import { ReactNode } from "react";

export default function FooterPDF({texto}: {texto?: string}){

    function renderPage( props: {pageNumber: number, totalPages: number, subPageNumber: number, subPageTotalPages: number} ): ReactNode{
        return `${props.pageNumber}`
    }

    return(
        <View style={[sg.bfooter, sg.footer]} fixed>
            <View style={[sg.dflexBtw]}>
                <Text style={[sg.tBold]}>{texto || "PJQRO"}</Text>
                <Text style={[sg.tBold]} render={renderPage}/>
            </View>
        </View>
    )
}